import { variantStyles } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const NoDataText = ({
  className,
  ...props
}: React.SVGProps<SVGTextElement>) => (
  <text
    style={{ transform: `translate(50%, 50%)` }}
    x={0}
    y={0}
    textAnchor="middle"
    dominantBaseline="middle"
    className={cn(variantStyles.bodySmall, className)}
    {...props}
  />
)

export const YAxisTickText = ({
  className,
  ...props
}: React.SVGProps<SVGTextElement>) => (
  <text
    x={0}
    y={0}
    fontSize={11}
    className={cn('fill-secondary', className)}
    textAnchor="start"
    dominantBaseline="middle"
    {...props}
  />
)

export const TooltipContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('bg-background p-3 shadow-md rounded-md', className)}
    {...props}
  />
)

export const TooltipLabel = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-sm font-medium mb-1', className)} {...props} />
)

export const TooltipItemContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex items-center gap-2', className)} {...props} />
)

export const TooltipColorIndicator = ({
  className,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('w-3 h-3 rounded-full', className)}
    style={style}
    {...props}
  />
)

export const TooltipItemText = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-sm text-gray-600', className)} {...props} />
)
